import _defineProperty2 from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import { Body as BaseBody } from './base';
import { TableContext } from './Table';
import { isRowExpanded } from './utils';

var flagVisibility = function flagVisibility(rows) {
  var visibleRows = rows.filter(function (oneRow) {
    return !oneRow.parent || oneRow.isExpanded;
  });

  if (visibleRows.length > 0) {
    visibleRows[0].isFirstVisible = true;
    visibleRows[visibleRows.length - 1].isLastVisible = true;
  }
};

var ContextBody =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextBody, _React$Component);

  function ContextBody() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContextBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContextBody)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onRow", function (row, rowProps) {
      var _this$props2 = _this.props,
          onRowClick = _this$props2.onRowClick,
          onRow = _this$props2.onRow;

      var extendedRowProps = _objectSpread({}, rowProps, onRow ? onRow(row, rowProps) : {});

      return {
        row: row,
        rowProps: extendedRowProps,
        onMouseDown: function onMouseDown(event) {
          var computedData = {
            isInput: event.target.tagName !== 'INPUT',
            isButton: event.target.tagName !== 'BUTTON'
          };
          onRowClick(event, row, rowProps, computedData);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "mapCells", function (headerData, row, rowKey) {
      // column indexes start after generated optional columns
      var additionalColsIndexShift = headerData[0].extraParams.firstUserColumnIndex;
      return _objectSpread({}, row && (row.cells || row).reduce(function (acc, cell, cellIndex) {
        var isCellObject = cell === Object(cell);

        var mappedCell = _defineProperty2({}, headerData[cellIndex + additionalColsIndexShift].property, {
          title: isCellObject ? cell.title : cell,
          props: _objectSpread({
            isVisible: true
          }, isCellObject ? cell.props : null)
        }); // increment the shift index when a cell spans multiple columns


        if (isCellObject && cell.props && cell.props.colSpan) {
          additionalColsIndexShift += cell.props.colSpan - 1;
        }

        return _objectSpread({}, acc, mappedCell);
      }, {
        id: row.id !== undefined ? row.id : rowKey
      }));
    });

    return _this;
  }

  _createClass(ContextBody, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          headerData = _this$props.headerData,
          rows = _this$props.rows,
          rowKey = _this$props.rowKey,
          children = _this$props.children,
          onRowClick = _this$props.onRowClick,
          props = _objectWithoutProperties(_this$props, ["className", "headerData", "rows", "rowKey", "children", "onRowClick"]);

      var mappedRows;

      if (headerData.length > 0) {
        mappedRows = rows.map(function (oneRow, oneRowKey) {
          return _objectSpread({}, oneRow, _this2.mapCells(headerData, oneRow, oneRowKey), {
            isExpanded: isRowExpanded(oneRow, rows),
            isFirst: oneRowKey === 0,
            isLast: oneRowKey === rows.length - 1,
            isFirstVisible: false,
            isLastVisible: false
          });
        });
        flagVisibility(mappedRows);
      }

      return React.createElement(React.Fragment, null, mappedRows && React.createElement(BaseBody, _extends({}, props, {
        mappedRows: mappedRows,
        rows: mappedRows,
        onRow: this.onRow,
        rowKey: rowKey,
        className: className
      })));
    }
  }]);

  return ContextBody;
}(React.Component);

_defineProperty(ContextBody, "propTypes", {
  className: _pt.string,
  children: _pt.node,
  headerData: _pt.arrayOf(_pt.any),
  rows: _pt.arrayOf(_pt.any),
  rowKey: _pt.any,
  onRowClick: _pt.any,
  onRow: _pt.any
});

export var TableBody = function TableBody(_ref) {
  var _ref$onRow = _ref.onRow,
      onRow = _ref$onRow === void 0 ? function () {
    return Object;
  } : _ref$onRow,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$rowKey = _ref.rowKey,
      rowKey = _ref$rowKey === void 0 ? 'id' : _ref$rowKey,
      _ref$onRowClick = _ref.onRowClick,
      onRowClick = _ref$onRowClick === void 0 ? function () {
    return undefined;
  } : _ref$onRowClick,
      props = _objectWithoutProperties(_ref, ["onRow", "className", "children", "rowKey", "onRowClick"]);

  return React.createElement(TableContext.Consumer, null, function (_ref2) {
    var _ref2$headerData = _ref2.headerData,
        headerData = _ref2$headerData === void 0 ? [] : _ref2$headerData,
        _ref2$rows = _ref2.rows,
        rows = _ref2$rows === void 0 ? [] : _ref2$rows,
        rest = _objectWithoutProperties(_ref2, ["headerData", "rows"]);

    return React.createElement(ContextBody, _extends({
      headerData: headerData,
      rows: rows,
      onRow: onRow,
      className: className,
      children: children,
      rowKey: rowKey,
      onRowClick: onRowClick
    }, props, rest));
  });
};
TableBody.propTypes = {
  className: _pt.string,
  children: _pt.node,
  headerData: _pt.arrayOf(_pt.any),
  rows: _pt.arrayOf(_pt.any),
  rowKey: _pt.any,
  onRowClick: _pt.any,
  onRow: _pt.any
};